/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { qreq } from "../shared/qrequest";
import Globals from "../shared/Globals";
import Alert from "./Alert";
import BaseCom from "./BaseCom";
import DataTable from "./DataTable";
import LoadingAlert from "./LoadingAlert";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { SidebarGlobal } from "./_SidebarGlobal";
import PrimaryButton from "./PrimaryButton";
import L from "./Lang";
import Icon from "./Icon";
import OptionButton from "./OptionButton";
import { Link } from "react-router-dom";

const LOAD_PATH = '/api/auditlog/list';


class AuditLogList extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            query: {},
            loaded: false,
            loading: false,
            list: []
        };
    }

    async componentDidMount() {
        await this.load();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load = async () => {
        this.setState({ loading: true });
        try {
            let j = await qreq.getAsync(LOAD_PATH);
            if (j.list) {
                this.setState({ list: j.list, loaded: true });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.setState({ loading: false });
    }

    new = () => {
        this.props.navigate(this.newURL);
    }

    setSubNav = () => {
        SidebarGlobal.setSubNav(<>
            {this.newUrl && <PrimaryButton onClick={this.new}>
                <span><Icon icon="faPlus" /> </span>
                <span className="d-none d-md-inline"><L>New</L></span>
            </PrimaryButton>}
            <OptionButton onClick={this.load} disabled={this.state.loading}>
                <span><Icon icon="faRefresh" spinner={this.state.loading} /> </span>
                <span className="d-none d-md-inline"><L>Refresh</L></span>
            </OptionButton>
        </>);
    }

    render() {
        const title = 'Audit Log';
        this.newURL = null;

        const header = (<h1>{title}</h1>);
        const columns = [
            /*{ name: 'id', title: 'ID', link: linkUrl, tooltip: tootlip },*/
            {
                name: 'userFullName', title: 'Who', valueFunc: row => {
                    if (row.userFullName)
                        return <Link to={'/user/edit/' + row.userID}>{row.userFullName}</Link>;
                    return <i><L>System</L></i>;
                }
            },
            {
                name: 'auditType', title: 'Type', valueFunc: row => {
                    if (row.auditType && row.auditType !== 'General')
                        return row.auditType;
                    return <i><L>General</L></i>;
                }
            },
            {
                name: 'message', title: 'Message', valueFunc: row => {
                    if (row.message) {
                        if (row.messageLinkPath)
                            return <Link to={row.messageLinkPath}>{row.message}</Link>
                        return <span>{row.message}</span>;
                    }
                    return <i><L>N/A</L></i>;
                }
            },
            {
                name: 'createdDate', title: 'Created Date', valueFunc: row => {
                    if (row.createdDate)
                        return Globals.toMDYHMLocalDateStringOrDiff(row.createdDate);
                    return <i><L>N/A</L></i>;
                }
            }
        ];

        this.setSubNav();

        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        if (this.state.errorMessage)
            return <Alert type="danger" icon="ExclamationTriangle" message={this.state.errorMessage} />

        return <div className="container-fluid" style={{ overflowY: 'auto' }}>
            {header}

            <DataTable columns={columns} data={this.state.list} loading={this.state.loading} />
        </div>;
    }
}

export default withParamsAndNavigate(AuditLogList);